import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.configuration-profiles')
  .factory('$configurationProfiles', ConfigurationProfilesObjectFactory);

/* @ngInject */
function ConfigurationProfilesObjectFactory($bringozFactory: $bringozFactory,
                                            ConfigurationProfilesAPI: BringozApi,
                                            ConfigurationProfiles_DS: DataStoreConfig) {
  function $configurationProfiles(id: string) {
    return $bringozFactory(id, ConfigurationProfilesAPI, ConfigurationProfiles_DS)
  }

  return $configurationProfiles;
}
